module.exports = __webpack_public_path__ + "static/media/hu.105d7847.svg";